import {
  ADD_TO_COMPARISON,
  REMOVE_FROM_COMPARISON,
  UPDATE_COMPARISON_AT_POSITION,
  CLEAR_COMPARISON,
  TOGGLE_DRAWER_COLLAPSED,
} from './ComparisonActions';

export const initialState = {
  selectedShingles: [],
  isDrawerCollapsed: true,
};

const comparisonReducer = (state, action = {}) => {
  if (state === undefined) {
    return initialState;
  }
  switch (action.type) {
    case ADD_TO_COMPARISON: {
      const { shingleUuid } = action.payload;

      // Don't add if already exists or if we have 3 items
      if (state.selectedShingles.includes(shingleUuid) || state.selectedShingles.length >= 3) {
        return state;
      }

      return {
        ...state,
        selectedShingles: [...state.selectedShingles, shingleUuid],
        // Auto-expand drawer when adding any item if currently collapsed
        isDrawerCollapsed: false,
      };
    }

    case REMOVE_FROM_COMPARISON: {
      const { shingleUuid } = action.payload;
      const newSelectedShingles = state.selectedShingles.filter(uuid => uuid !== shingleUuid);

      // If no change occurred, return current state
      if (newSelectedShingles.length === state.selectedShingles.length) {
        return state;
      }

      return {
        ...state,
        selectedShingles: newSelectedShingles,
      };
    }

    case UPDATE_COMPARISON_AT_POSITION: {
      const { position, shingleUuid } = action.payload;

      // Create a new array with the same length, replacing the item at the specific position
      const newSelectedShingles = [...state.selectedShingles];

      // If position is within current array bounds, replace the item
      if (position < newSelectedShingles.length) {
        newSelectedShingles[position] = shingleUuid;
      } else {
        // If position is beyond current array, this shouldn't happen in normal flow
        // but handle it gracefully by adding the item to the end
        newSelectedShingles.push(shingleUuid);
      }

      return {
        ...state,
        selectedShingles: newSelectedShingles,
      };
    }

    case CLEAR_COMPARISON:
      return initialState;

    case TOGGLE_DRAWER_COLLAPSED:
      return {
        ...state,
        isDrawerCollapsed: !state.isDrawerCollapsed,
      };

    default:
      return state;
  }
};

export default comparisonReducer;
